import { Box } from '@chakra-ui/react';
import { useTheme } from '@emotion/react';

export const Paper = ({ ...props }) => <Box py={3} px={0} bg="white" {...props} borderRadius="8px" />;

export const PaperWithShadow = ({ ...props }) => {
  const theme = useTheme();

  return <Box py={3} px={0} bg="white" borderRadius="8px" boxShadow={theme.shadows.paper} {...props} />;
};
